var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconKebabBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_35015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 10.4998C9.16602 10.7209 9.25381 10.9328 9.41009 11.0891C9.56637 11.2454 9.77834 11.3332 9.99935 11.3332C10.2204 11.3332 10.4323 11.2454 10.5886 11.0891C10.7449 10.9328 10.8327 10.7209 10.8327 10.4998C10.8327 10.2788 10.7449 10.0669 10.5886 9.91058C10.4323 9.7543 10.2204 9.6665 9.99935 9.6665C9.77834 9.6665 9.56637 9.7543 9.41009 9.91058C9.25381 10.0669 9.16602 10.2788 9.16602 10.4998Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 16.3333C9.16602 16.5543 9.25381 16.7663 9.41009 16.9226C9.56637 17.0789 9.77834 17.1667 9.99935 17.1667C10.2204 17.1667 10.4323 17.0789 10.5886 16.9226C10.7449 16.7663 10.8327 16.5543 10.8327 16.3333C10.8327 16.1123 10.7449 15.9004 10.5886 15.7441C10.4323 15.5878 10.2204 15.5 9.99935 15.5C9.77834 15.5 9.56637 15.5878 9.41009 15.7441C9.25381 15.9004 9.16602 16.1123 9.16602 16.3333Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 4.66683C9.16602 4.88784 9.25381 5.0998 9.41009 5.25608C9.56637 5.41237 9.77834 5.50016 9.99935 5.50016C10.2204 5.50016 10.4323 5.41237 10.5886 5.25608C10.7449 5.0998 10.8327 4.88784 10.8327 4.66683C10.8327 4.44582 10.7449 4.23385 10.5886 4.07757C10.4323 3.92129 10.2204 3.8335 9.99935 3.8335C9.77834 3.8335 9.56637 3.92129 9.41009 4.07757C9.25381 4.23385 9.16602 4.44582 9.16602 4.66683Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_35015"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKebabBlack);
export default __webpack_public_path__ + "static/media/Icon_Kebab_Black.bb870007ba2195a5f4638fc6c1bc82e4.svg";
export { ForwardRef as ReactComponent };